import React, { Component } from "react";
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
import { GOOGLE_API_KEY } from "constant.js";

export class MapContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            marker: this.props.marker,
        };
    }

    render() {
        return (
            <Map
                key={this.props.key}
                google={this.props.google}
                zoom={this.props.zoom}
                initialCenter={this.props.center}
                center={this.props.center}
                containerStyle={{ width: '100%', height: this.props.height, minHeight:300, position: 'relative' }}
            >

                {this.state.marker.map((el, index) => {
                    if (el.mini) {
                        return (
                            <Marker
                                key={"marker-" + index}
                                title={el.name}
                                name={el.name}
                                position={el.position}
                                icon={{
                                    url: "https://cdn.pixabay.com/photo/2014/04/03/10/03/google-309739_960_720.png",
                                    anchor: new this.props.google.maps.Point(8, 24),
                                    scaledSize: new this.props.google.maps.Size(16, 24)
                                }}
                            />
                            )
                    }
                    return (
                        <Marker
                            key={"marker-"+index}
                            title={el.name}
                            name={el.name}
                            position={el.position}
                        />
                    )
                })}
            </Map>
        );
    }
}

MapContainer.defaultProps = {
    marker: [],
    center: {
        lat: 40.854885,
        lng: -88.081807
    },
    zoom: 13,
    height: "auto",
    key: 1,
}



export default GoogleApiWrapper({
  apiKey: (GOOGLE_API_KEY)
})(MapContainer)